import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useRouter } from 'hooks/useRouter';

export const useOpenSignedDocument = ({ token, documentName }) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const { query: q } = useRouter();

  const { teamId, folderId, documentId } = q;

  const fn = async () => {
    const response = await client.fetchSignedDocument(
      teamId as string,
      folderId as string,
      documentId as string,
    );

    const a = window.document.createElement('a');
    a.href = URL.createObjectURL(response?.data);
    a.download = `${documentName} - CINCEL.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const query = useMutation(fn);

  return { ...query };
};
